<template>
  <div class="login-consent">
    <el-checkbox :value="value" :aria-label="english ? 'I agree to the Membership Service Agreement and Privacy Policy' : '我已阅读并同意会员服务协议和隐私政策'" @input="$emit('input', $event)">
      <span>{{ english ? 'I agree to the' : '我已阅读并同意' }}</span>
    </el-checkbox>
    <span class="login-consent-links">
      <button type="button" @click="open('membership')">{{ english ? 'Membership Service Agreement' : '《会员服务协议》' }}</button>
      <span>{{ english ? ' and ' : '和' }}</span>
      <button type="button" @click="open('privacy')">{{ english ? 'Privacy Policy' : '《隐私政策》' }}</button><span v-if="english">.</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'LoginConsent',
  props: {
    value: Boolean,
    english: Boolean
  },
  methods: {
    open(type) {
      const privacy = type === 'privacy';
      const title = this.english
        ? (privacy ? 'Privacy Policy' : 'Membership Service Agreement')
        : (privacy ? '隐私政策' : '会员服务协议');
      const key = (privacy ? 'PRIVACY_CLAUSE' : 'MEMBERSHIP_SERVICE_AGREEMENT') + (this.english ? '_EN' : '');
      this.$emit('open', title, key);
    }
  }
};
</script>

<style lang="scss" scoped>
.login-consent {
  color: #606266;
  font-size: 14px;
  line-height: 24px;
  overflow-wrap: anywhere;
  ::v-deep .el-checkbox {
    margin-right: 4px;
    color: inherit;
    font-weight: normal;
    .el-checkbox__label {
      padding-left: 8px;
      color: inherit;
    }
    .el-checkbox__inner {
      border-color: #909399;
    }
    .is-checked .el-checkbox__inner {
      border-color: #ed6f33;
      background: #ed6f33;
    }
  }
  button {
    display: inline;
    padding: 0;
    border: 0;
    color: #ed6f33;
    background: transparent;
    font: inherit;
    text-align: left;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    &:focus-visible {
      outline: 2px solid #ed6f33;
      outline-offset: 2px;
    }
  }
}
</style>
